import { render, staticRenderFns } from "./dynamicProperty.vue?vue&type=template&id=6c89bc95&scoped=true&"
import script from "./dynamicProperty.vue?vue&type=script&lang=js&"
export * from "./dynamicProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c89bc95",
  null
  
)

export default component.exports